"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Utility_1 = require("../../../Icons/Utility");
var Checkbox_1 = __importDefault(require("../../../Checkbox"));
var Typography_1 = require("../../../Typography");
var styles_1 = __importDefault(require("../styles"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare
var CheckboxGroup = function (_a) {
    var className = _a.className, disabled = _a.disabled, errorMessage = _a.errorMessage, groupLabel = _a.groupLabel, helperText = _a.helperText, name = _a.name, onGroupChange = _a.onGroupChange, options = _a.options, showGroupLabel = _a.showGroupLabel, twoColumn = _a.twoColumn, children = _a.children, tooltip = _a.tooltip, divProps = __rest(_a, ["className", "disabled", "errorMessage", "groupLabel", "helperText", "name", "onGroupChange", "options", "showGroupLabel", "twoColumn", "children", "tooltip"]);
    var hasError = !!errorMessage;
    var classes = useStyles({ error: hasError });
    var checkboxGroupLabelId = "".concat(name, "_label");
    var helperTextId = "".concat(name, "_helperText");
    var labelTextColor = disabled
        ? 'disabled'
        : 'primary';
    var helperTextColor = disabled
        ? 'disabled'
        : 'secondary';
    // if groupLabel is visible, mark which element labels the group
    // otherwise, add an aria-label
    var checkboxGroupProps = (function () {
        var ariaAttrs = {};
        if (showGroupLabel) {
            ariaAttrs['aria-labelledby'] = checkboxGroupLabelId;
        }
        else {
            ariaAttrs['aria-label'] = groupLabel;
        }
        if (helperText) {
            ariaAttrs['aria-describedby'] = helperTextId;
        }
        return ariaAttrs;
    })();
    var initialCheckedOptions = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = options === null || options === void 0 ? void 0 : options.reduce(function (allInitialOptions, currentOption) {
            if (!currentOption.subList && currentOption.defaultChecked) {
                allInitialOptions.push(currentOption.value);
            }
            if (currentOption.subList) {
                allInitialOptions.push.apply(allInitialOptions, currentOption.subList
                    .filter(function (childOption) {
                    return currentOption.defaultChecked || childOption.defaultChecked;
                })
                    .map(function (childOption) { return childOption.value; }));
            }
            return allInitialOptions;
        }, [])) !== null && _a !== void 0 ? _a : [];
    }, [options]);
    var _b = (0, react_1.useState)(initialCheckedOptions), checkedOptions = _b[0], setCheckedOptions = _b[1];
    var handleCheckboxChange = function (value) {
        var newCheckedOptions = __spreadArray([], checkedOptions, true);
        var optionIndex = newCheckedOptions.findIndex(function (checkedValue) { return checkedValue === value; });
        if (optionIndex === -1) {
            newCheckedOptions.push(value);
        }
        else {
            newCheckedOptions.splice(optionIndex, 1);
        }
        return newCheckedOptions;
    };
    var handleIndeterminateParentChange = function (childOptions, isParentChecked) {
        var newCheckedOptions = __spreadArray([], checkedOptions, true);
        childOptions.forEach(function (child) {
            var optionIndex = newCheckedOptions.findIndex(function (checkedValue) { return checkedValue === child.value; });
            if (isParentChecked) {
                if (optionIndex === -1) {
                    newCheckedOptions.push(child.value);
                }
            }
            else if (optionIndex > -1) {
                newCheckedOptions.splice(optionIndex, 1);
            }
        });
        return newCheckedOptions;
    };
    var handleChange = function (event, option) {
        var newCheckedOptions;
        if (option.subList) {
            newCheckedOptions = handleIndeterminateParentChange(option.subList, event.target.checked);
        }
        else {
            newCheckedOptions = handleCheckboxChange(option.value);
        }
        setCheckedOptions(newCheckedOptions);
        if (onGroupChange) {
            onGroupChange(event, newCheckedOptions);
        }
        if (option.onChange) {
            option.onChange(event, newCheckedOptions);
        }
    };
    var getCheckedState = function (option) {
        // non-nested checkboxes
        if (!option.subList) {
            return { checked: checkedOptions.includes(option.value) };
        }
        // nested checkboxes
        var checked = option.subList.every(function (nestedCheckbox) {
            return checkedOptions.includes(nestedCheckbox.value);
        });
        var indeterminate = !checked &&
            option.subList.some(function (nestedCheckbox) {
                return checkedOptions.includes(nestedCheckbox.value);
            });
        return { checked: checked, indeterminate: indeterminate };
    };
    var renderCheckboxesWithOptions = function () {
        return options === null || options === void 0 ? void 0 : options.map(function (option) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Checkbox_1.default, __assign({ key: "".concat(name, "_").concat(option.value), className: classes.inputWrapper, disabled: option.disabled || disabled, error: hasError, value: option.value, helpText: option.helpText, name: name, label: option.label, onChange: function (event) { return handleChange(event, option); } }, getCheckedState(option))),
            option.subList &&
                option.subList.map(function (childOption) { return (react_1.default.createElement(Checkbox_1.default, __assign({ key: "".concat(name, "_").concat(childOption.value), className: (0, classnames_1.default)(classes.inputWrapper, 'nested'), disabled: childOption.disabled || disabled, value: childOption.value, helpText: childOption.helpText, name: name, label: childOption.label, onChange: function (event) { return handleChange(event, childOption); } }, getCheckedState(childOption)))); }))); });
    };
    var renderCheckboxesWithChildren = function () {
        return react_1.default.Children.map(children, function (child) {
            if (!(react_1.default.isValidElement(child) && child.type === Checkbox_1.default)) {
                console.warn('Checkbox is the only valid child of CheckboxGroup. Other nodes will be skipped.');
                return null;
            }
            return react_1.default.cloneElement(child, {
                className: (0, classnames_1.default)(classes.inputWrapper, child.props.className),
                disabled: child.props.disabled || disabled,
                error: hasError,
                name: name
            });
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ role: "group", className: (0, classnames_1.default)(className, classes.wrapper, twoColumn && classes.twoColumn) }, checkboxGroupProps, divProps),
            (showGroupLabel || helperText) && (react_1.default.createElement("div", { className: classes.groupDescriptionWrapper },
                showGroupLabel && (react_1.default.createElement("span", { className: classes.legendAndTooltipWrapper },
                    react_1.default.createElement(Typography_1.LabelText, { color: labelTextColor, size: "large", id: checkboxGroupLabelId }, groupLabel),
                    tooltip)),
                helperText && (react_1.default.createElement(Typography_1.UtilityText, { color: helperTextColor, size: "xsmall", id: helperTextId }, helperText)))),
            options
                ? renderCheckboxesWithOptions()
                : renderCheckboxesWithChildren()),
        errorMessage && (react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: "secondary", className: classes.errorTextWrapper },
            react_1.default.createElement("span", { className: classes.errorIconWrapper },
                react_1.default.createElement(Utility_1.AlertWarning, { size: "medium", color: "warningAccessible", ariaHidden: true })),
            errorMessage))));
};
exports.default = CheckboxGroup;
